import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsHeatmap from 'highcharts/modules/heatmap';

HighchartsHeatmap(Highcharts);

const HeatMap = ({ data = [], labelsX = [], labelsY = [] }) => {
  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const options = {
    credits: {
      enabled: false,
    },
    colors: ['#fff'],
    chart: {
      type: 'heatmap',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: labelsX,
      lineWidth: 0,
    },

    yAxis: {
      categories: labelsY,
      title: null,
      reversed: true,
      opposite: true,
      gridLineWidth: 0,
      tickInterval: 2,
      showLastLabel: false,
    },
    colorAxis: {
      min: 0,
      minColor: '#d7e5df',
      maxColor: '#4b8c6f',
    },
    tooltip: {
      backgroundColor: '#fff',
      borderRadius: 4,
      borderColor: '#ddd',
      borderWidth: 1,
      shadow: false,
      shape: 'rect',
      distance: 24,
      pointFormatter: function () {
        return `<b>${this.value}</b><br/>${days[this.x]} - ${labelsY[this.y]}`;
      },
      headerFormat: '',
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: '',
        borderWidth: 4,
        data,
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default HeatMap;
